<template>
  <ul class="list-group list-group-flush tx-13">
    <li class="list-group-item d-flex pd-sm-x-20" v-if="tasks.length == 0">
      <div class="container d-flex justify-content-center ht-100p">
        <div
          class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
        >
          <div class="wd-80p wd-sm-300 mg-b-15">
            <img src="assets/svg/boxempty.svg" alt="" class="img-fluid" />
          </div>
          <h4 class="tx-18 text-muted">Яг одоо буй уншиж буй ном алга байна</h4>
        </div>
      </div>
    </li>
    <template v-else>
      <li
        class="list-group-item d-flex pd-sm-x-20"
        v-for="(t, i) in tasks"
        :key="i"
        @click="$emit('on-item-modal', t)"
        role="button"
      >
        <div class="avatar d-none d-sm-block">
          <span class="avatar-initial rounded-circle bg-teal"
            ><feather type="check-square" class="ht-20-f wd-20-f"></feather
          ></span>
        </div>
        <div class="pd-sm-l-10">
          <p class="tx-medium mg-b-0">{{ t.task }}</p>
          <small class="tx-12 tx-color-03 mg-b-0">{{
            t.createdDate | moment("YYYY.MM.DD HH:mm, dddd")
          }}</small>
        </div>
        <div class="mg-l-auto text-right">
          <p class="tx-medium mg-b-0">{{ t.organizationTask.task }}</p>
          <button class="btn btn-xs btn-outline-primary mg-t-5">
            Үнэлгээ, сэтгэгдэл
          </button>
        </div>
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  props: {
    tasks: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style></style>
